import { Col, Row, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react'
import { Button, Modal, Upload, message } from 'antd';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteOutlined, UploadOutlined, LinkOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
// import { usePermission } from '../../../hooks/usePermission';
import { AbhaLinked, AbhaLinkedServices, AbhaServices } from '../../../redux/Services';
import AbhaLinkedFilter from '../AbhaFilter';
import moment from 'moment';
import { json } from 'react-router-dom';
import AttachmentUpload from './AttachmentUpload';
const AbhaCreated = () => {
    // const permission = usePermission("Faqs", "List");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const abhaCreatedList = useSelector(state => state.abhaCreated.abhaCreatedList || []);
    // const totalFaq = useSelector(state => state.faq.totalFaq || "");
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    const [file, setFile] = useState("");
    const { mutate: getabhaCreatedList, isLoading } = useMutation((data) => dispatch(AbhaServices.abhaCreatedList(data)));
    const { mutate: addattachmentApi } = useMutation((data) => dispatch(AbhaLinkedServices.addattachmentApi(data)));
    const [modal1Open, setModal1Open] = useState(false);
    const [raw, setRaw] = useState({});


    useEffect(() => {
        getabhaCreatedList({});
        return () => { }
    }, [filter])
    // console.log(abhaCreatedList);
    const props = {
        name: 'file',
        action: addattachmentApi,
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
        },

    };
    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'sno',
            key: 'sno',
            className: 'table_first_col',
            render: (value, item, index) => (page - 1) * 10 + index + 1
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'actiion',
            className: '',
            render: (value, item, index) => {
                return (
                    <> <Tooltip placement="top" title={"Upload File"}>
                        <AttachmentUpload
                            file={file}
                            setFile={setFile}
                            handleChange={(name) => {
                                setFile(name);
                            }}
                            accept="image/jpeg,image/png,image/jpg"
                        />
                    </Tooltip>
      
                    </>
                )
            }
        },
        {
            title: 'Log Id',
            dataIndex: 'id',
            key: 'id',
            className: 'table_status_col',

        },
        {
            title: 'Log Type',
            dataIndex: 'log_type',
            key: 'log_type',
            className: 'table_status_col',
            name: 'type'
        },
        {
            title: 'Request Id',
            dataIndex: 'id',
            key: 'id',
            className: 'text-capitalize',
        },

        {
            title: 'Requester (HIU/HIP)',
            dataIndex: 'requestor',
            key: 'requestor',
            className: 'text-capitalize',
        },


        {
            title: 'Patient Name/Patient Id',
            dataIndex: 'raw_data',
            key: 'raw_data',
            className: 'table_status_col patient',
            render: (value, item, index) => {
                return (
                    <span>
                        {JSON.parse(item?.raw_data || "{}")?.name}

                    </span>
                )
            }
        },
        {
            title: 'PHR Address',
            dataIndex: 'health_id',
            key: 'health_id',
            className: 'table_status_col',

        },

        {
            title: 'URL',
            dataIndex: 'request_url',
            key: 'request_url',
            className: 'table_status_col',

        },
        {
            title: 'Date Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            className: 'abha-link-date',
            render: (value, item, index) => {
                return (
                    <>{moment(item.createdAt).format('DD-MM-YYYY H:mm:ss')}</>
                )
            }
        },
        {
            title: 'Requested Data',
            dataIndex: 'action',
            key: 'action',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <><Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.raw_data || "{}")); setModal1Open(true); }}> View</Button>
                    </>
                )

            }
        },
        {
            title: 'Response Data',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <Button className="view-btn" type="primary" onClick={() => { setRaw(JSON.parse(item?.raw_data || "{}")); setModal1Open(true); }} > View</Button>
                )
            }
        },
    ];
    return (
        <div>
            <Row gutter={[10, 10]} align={"middle"}>
                <Col lg={3} md={24} sm={24} xs={24}>
                    <HeadingBack title={"Abha Linked Report"} subHeading={`Records ${35 || 0}`} />
                </Col>
                <Col lg={19} md={12} sm={24} xs={24}>
                    <AbhaLinkedFilter filter={filter} setFilter={setFilter} setPage={setPage} />
                </Col>
            </Row>
            <div className='tableResponsive mt-10'>
                <Table
                    rowKey='Id'
                    className={isLoading ? 'table antd_table no_data_found_hide' : 'table antd_table'}
                    bordered
                    columns={columns}
                    dataSource={Array.isArray(abhaCreatedList) && abhaCreatedList?.length > 0 ? abhaCreatedList : []}
                    pagination={{
                        current: page,
                        pageSize: 10,
                        onChange(current, pageSize) {
                            setPage(current);
                        },
                        hideOnSinglePage: true,
                        /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
                    }}

                />

            </div>

            <Modal
                style={{
                    top: 20,
                }}
         
                open={modal1Open}
                onOk={() => setModal1Open(false)}
                onCancel={() => { setRaw({}); setModal1Open(false); }}
                footer={null}

            >

                <pre>{JSON.stringify(raw, null, 2)}</pre>

            </Modal>
        </div>
    )
}

export default AbhaCreated